module.exports = __webpack_public_path__ + "img/yingxiao_cishu_icon.be093fd9.png";